import { Box } from '@mui/material';

export default function NoDataFound({ displayText = 'No data found' }: { displayText?: string }) {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
      {displayText}
    </Box>
  );
}
